import React from 'react';
import { AbsoluteFill, useCurrentFrame } from 'remotion';

// 発能思维导图
export const MindMapAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const nodes = ['中心主题', '分支1', '分支2', '分支3'];
  
  return (
    <AbsoluteFill style={{ background: '#1a1a2e', padding: 80, color: 'white' }}>
      <h1 style={{ fontSize: 60, marginBottom: 60 }}>思维导图</h1>
      {nodes.map((node, i) => (
        <div key={i} style={{
          padding: '30px 50px',
          background: i === 0 ? '#667eea' : '#2d2d44',
          borderRadius: 20,
          fontSize: 40,
          margin: 20,
          opacity: frame > i * 30 ? 1 : 0.3,
        }}>
          {node}
        </div>
      ))}
    </AbsoluteFill>
  );
};
